// Map partner roles to effective access roles
export const roleMapping: Record<string, string[]> = {
    'MASTER': ['ADMIN', 'WAREHOUSE', 'COURIER'],
    'DRIVER': ['COURIER'],
    'WAREHOUSE_STAFF': ['WAREHOUSE'],
    // Shorthand role aliases for convenience
    'ADMIN': ['ADMIN', 'WAREHOUSE', 'COURIER'],
    'WAREHOUSE': ['WAREHOUSE'],
    'COURIER': ['COURIER']
};

// Maps dashboard card names to required access roles
export const cardRoles: Record<string, string[]> = {
    'courier': ['ADMIN', 'COURIER'],
    'incoming': ['ADMIN', 'WAREHOUSE'],
    'dispatch': ['ADMIN', 'WAREHOUSE'],
};

// Maps route paths to required access roles
export const routeRoles: Record<string, string[]> = {
    '/courier': ['ADMIN', 'COURIER'],
    '/incoming': ['ADMIN', 'WAREHOUSE'],
    '/dispatch': ['ADMIN', 'WAREHOUSE'],
    '/dashboard/warehouse': ['ADMIN', 'WAREHOUSE'],
    '/dashboard/partner': ['ADMIN', 'COURIER'],
};

export const getEffectiveRoles = (role: string | undefined): string[] => {
    if (!role) return [];
    return roleMapping[role] || [];
};

export const hasAccess = (userRole: string | undefined, requiredRoles: string[]): boolean => {
    const effective = getEffectiveRoles(userRole);
    return effective.some(r => requiredRoles.includes(r));
};
